/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const NotificationTopic = zod
  .enum([
    'content-shares',
    'group-invites',
    'booking-task-updates',
    'payment-receipts',
    'chat-invitations',
    'thread-messages',
  ])
  .describe(
    'Notification category: content shares, group invitations, booking & task updates, payment receipts, or chat invitations',
  );

export type NotificationTopic = zod.input<typeof NotificationTopic>;
export type NotificationTopicOutput = zod.output<typeof NotificationTopic>;
